













import { defineComponent, PropType } from '@nuxtjs/composition-api'

export default defineComponent({
  props: {
    list: {
      type: Array,
      default: () => [],
    },
    size: {
      type: String as PropType<'xs' | 'md'>,
      default: 'xs',
    },
    skeleton: {
      type: Boolean,
      default: false,
    },
    iconColor: {
      type: String,
      default: 'secondary',
    },
  },
  setup (props) {
    const getIconClass = (icon: string) => {
      return {
        [icon]: true,
        [`text-${props.iconColor}`]: true,
      }
    }

    return {
      getIconClass,
    }
  },
})
